<!-- Choice pills of a Vue dialog: the legacy .pill-btn look (the legacy selectPill / setSelectedPillValue). Single choice: v-model is the chosen value; multiple: v-model is the list of chosen values (keepOne: the
     last one on cannot be turned off). Each button keeps data-value = the stored value (never translated: show it with
     a translated label; an option with hidden stays in the page with class "hidden"). Pass the container's layout with class (e.g. "flex gap-2 flex-wrap") and its id if other code
     looks for it. -->
<script setup lang="ts">
import { togglePill, type PillOption } from '../../features/dialogs'

const props = withDefaults(defineProps<{ options: PillOption[]; modelValue: string | string[]; multiple?: boolean; keepOne?: boolean }>(),
  { multiple: false, keepOne: false })
const emit = defineEmits<{ 'update:modelValue': [value: string | string[]] }>()

const isOn = (v: string) => (Array.isArray(props.modelValue) ? props.modelValue.includes(v) : props.modelValue === v)
function pick(v: string) {
  if (props.multiple) emit('update:modelValue', togglePill(Array.isArray(props.modelValue) ? props.modelValue : [], v, props.keepOne))
  else emit('update:modelValue', v)
}
</script>

<template>
  <div>
    <button v-for="o in options" :key="o.value" type="button" :data-value="o.value"
      :class="['pill-btn px-4 py-2 rounded-full font-bold text-xs transition', isOn(o.value) ? 'bg-brand text-white' : 'bg-darkinput text-gray-400', { hidden: o.hidden }]"
      @click="pick(o.value)">{{ o.label }}</button>
  </div>
</template>
